import type { App } from 'vue';
// 导入所有自定义指令
import focus from './custom/focus';
import dataAuth from './custom/dataAuth';
import dragable from './custom/dragable';
import contextmenu from './custom/contextmenu';

/**
 * 注册所有自定义指令
 *
 * 指令文件存放在 ./custom/ 目录下
 * 新增指令步骤：
 * 1. 在 ./custom/ 目录下创建指令文件
 * 2. 在此文件中导入并注册
 */
export default function (app: App) {
    app.directive('focus', focus);
    app.directive('dataAuth', dataAuth);
    app.directive('dragable', dragable);
    app.directive('contextMenu', contextmenu);
}
